import API from "../../api/api";
import React, { Component } from "react";
import "../../styles/css/responsive.css";
import "../../styles/css/dashboard/dashboard.css";
import { Wrapper, HeaderCard } from "../../components";
import { Container, Row, Col, Button } from "bootstrap-4-react";
import DetailCard from "../../components/ProjectCards/DetailCard";
import CircularProgress from "@material-ui/core/CircularProgress";
import ProjectCard from "../../components/ProjectCards/ProjectCard";
import { Link } from "react-router-dom";
import TabComponent from "./Tab";

const userRole = localStorage.getItem("userRole");

class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      detailsData: [],
      jobData: [],
      isDashboardLoading: true,

      // searchParams
      searchKey: "",
      surveyType: "",
    };
  }

  componentDidMount() {
    this.getJobs();
  }

  async searchJobs(key, type) {
    await this.setState({
      searchKey: key,
      surveyType: type,
    });
    await this.getJobs();
  }

  async getJobs() {
    await this.setState({
      isDashboardLoading: true,
    });
    const url =
      userRole === "Title Company Admin" || userRole === "Title Company User"
        ? "dashboard/title"
        : userRole === "Surveyor" || userRole === "Surveyor User"
        ? "dashboard/survey"
        : null;

    await API.get(
      `${url}?job_name=${this.state.searchKey}&survey_type=${this.state.surveyType}`
    )
      .then((res) => {
        this.setState({
          detailsData: res.data.response.card && res.data.response.card,
          jobData: res.data.response.jobs && res.data.response.jobs,
          isDashboardLoading: false,
        });
      })
      .catch((err) => {
        this.setState({ isDashboardLoading: false });
        console.log("AXIOS ERROR: ", err);
      });
  }

  render() {
    const { detailsData, jobData, isDashboardLoading } = this.state;

    return (
      <Wrapper>
        <div className="headerSpace">
          <Container>
            <Row>
              <Col col="sm-12 md-12 lg-12">
                <div>
                  <HeaderCard searchJobs={this.searchJobs.bind(this)} />
                </div>
              </Col>
            </Row>
            {isDashboardLoading ? (
              <div className="preloader">
                <CircularProgress className="preloaderCircle" />
              </div>
            ) : (
              <Row>
                {/* <Col col="sm-12 md-12 lg-12">
                  <Link to="/PropertyForm">
                    <Button variant="contained" color="primary" details={detailsData}>
                      ELEVATION CERTIFICATE FORM
                    </Button>
                  </Link>{" "}
                </Col> */}
                <Col col="sm-12 md-12 lg-3">
                  <div>
                    <DetailCard details={detailsData} />
                  </div>
                </Col>
                <Col col="sm-12 md-12 lg-9">
                  <TabComponent jobData={jobData} />
                  {/* <div>
                    {userRole !== "Admin" &&
                      jobData &&
                      jobData.map((job) => {
                        return <ProjectCard key={job.id} jobData={job} />;
                      })}
                  </div> */}
                </Col>
              </Row>
            )}
          </Container>
        </div>
      </Wrapper>
    );
  }
}

export default Dashboard;



// WEBPACK FOOTER //
// ./src/pages/Dashboard/Dashboard.js